import GameBannerDisplay from './GameBannerDisplay'

export default GameBannerDisplay